import * as React from "react";

interface props {
  className?: string;
}
const DocumentTypeSVG = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    version="1"
    viewBox="0 0 48 48"
  >
    <path fill="#90CAF9" d="M40 45H8V3h22l10 10z"></path>
    <path fill="#E1F5FE" d="M38.5 14H29V4.5z"></path>
    <g fill="#1976D2">
      <path d="M16 21h17v2H16zM16 25h13v2H16zM16 29h17v2H16zM16 33h13v2H16z"></path>
    </g>
  </svg>
);

export default DocumentTypeSVG;
